import { tokenizeVariableContent } from '@/components/organisms/template-variable-editor/template-variable-tokenizer.util'

import type { TemplateVariableFormValues } from './template-variable-form.interface'

const VARIABLE_BLOCK_REGEX = /\{([^{}]+)\}/g

/**
 * Substitutes template variable blocks with actual values.
 * Parses `{variableName:type:constraints:modifiers}` syntax and replaces
 * each block with the corresponding value from the values map.
 * Variables not found in the values map are left as-is.
 */
export const substituteTemplateVariables = (
  content: string,
  values: TemplateVariableFormValues
): string =>
  content.replace(VARIABLE_BLOCK_REGEX, (fullMatch, inner: string) => {
    const tokenList = tokenizeVariableContent(inner)
    const name = tokenList[0]?.trim()

    if (!name || !(name in values)) return fullMatch

    return String(values[name])
  })
